<template>
    <q-modal v-model="show_survey" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}"  no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="hideModal()" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ survey_title }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row gutter-sm">
                    <div class="col-12 q-mt-sm" v-if="question_type != 5 && survey_question_id">
                        <span class="text-weight-bold">{{ title }}</span>

                        <q-field :error="$v.survey_question_answer.$error" :error-label="$t('select_at_least_one_option')">
                            <q-option-group
                                color="secondary"
                                :type="question_type === 1 || question_type === 2 ? 'radio' : 'checkbox'"
                                v-model="survey_question_answer"
                                :options="survey_question_answers.map(s => { return { value: s.title, label: s.title } })"
                                @input="$v.survey_question_answer.$touch"
                            />
                        </q-field>
                    </div>

                    <div class="col-12" v-if="question_type === 2 || question_type === 4">
                        <span class="text-weight-bold">{{ $t('justify') }}</span>

                        <q-input v-model="justification" :float-label="$t('justification')" type="textarea" rows="3" :error="$v.justification.$error" @input="$v.justification.$touch" />
                    </div>

                    <div class="col-12" v-if="question_type === 5">
                        <span class="text-weight-bold">{{ title }}</span>

                        <q-input v-model="answer" :float-label="$t('answer')" type="textarea" rows="3" :error="$v.answer.$error" @input="$v.answer.$touch" />
                    </div>
                </div>

                <div class="row gutter-sm justify-end q-mt-lg">
                    <div class="col-xs-12 col-sm-3">
                        <q-btn color="secondary" class="full-width" :label="$t('send')" icon="far fa-paper-plane" @click="sendSurvey()" />
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
    props: ['show', 'survey_id'],

    data() {
        return {
            survey_question_id: '',
            survey_title: '',
            survey_description: '',
            title: '',
            question_type: '',
            survey_question_answers: [],
            survey_question_answer: null,
            justification: '',
            answer: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            has_mandatory_surveys: 'common/has_mandatory_surveys'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_survey: {
            get() {
                return this.show
            },
            set() {
                this.$emit('hide_survey')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        fetchSurvey() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_surveys/surveys/${this.survey_id}/`, this.getHeader)
            .then(response => {
                this.populateSurvey(response.data)
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        sendSurvey() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()

                fd.append('survey_question_id', this.survey_question_id)

                if (this.question_type === 1 || this.question_type === 2) {
                    fd.append('answers', this.survey_question_answer)
                }
                else if (this.question_type === 3 || this.question_type === 4) {
                    this.survey_question_answer.map(s => fd.append('answers', s))
                }
                else if (this.question_type === 5) {
                    fd.append('answers', this.answer)
                }

                if (this.question_type === 2 || this.question_type === 4) fd.append('justification', this.justification)

                this.$axios.post(`/etraining_surveys/surveys/${this.survey_id}/submit_answer/`, fd, this.getHeader)
                .then(response => {
                    if (response.data.id) {
                        this.clearSurveyAnswers(response.data)
                    }
                    else {
                        this.hideModal()
                    }
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
        },

        populateSurvey(data) {
            this.survey_question_id = data.id
            this.survey_title = data.survey_title
            this.survey_description = data.survey_description
            this.title = data.title
            this.question_type = data.question_type
            this.survey_question_answers = data.survey_question_answers

            if (this.question_type === 1 || this.question_type === 2) this.survey_question_answer = ''
            else if (this.question_type === 3 || this.question_type === 4) this.survey_question_answer = []
        },

        clearSurveyAnswers(data) {
            this.$v.$reset()
            this.survey_question_answers = []
            this.survey_question_answer = null
            this.justification = ''
            this.answer = ''

            if (data) this.populateSurvey(data)
        },

        hideModal() {
            this.clearSurveyAnswers()
            this.$emit('hide_survey')
        }
    },

    watch: {
        show_survey: function() {
            if (this.show_survey) {
                this.fetchSurvey()
            }
        }
    },

    created() {
        if (this.show_survey) this.fetchSurvey()
    },

    validations() {
        return {
            survey_question_answer: {
                requiredIf: requiredIf(() => {
                    return this.question_type !== 5 ? true : false
                })
            },

            justification: {
                requiredIf: requiredIf(() => {
                    return this.question_type === 2 || this.question_type === 4 ? true : false
                })
            },

            answer: {
                requiredIf: requiredIf(() => {
                    return this.question_type === 5 ? true : false
                })
            },
        }
    }
}
</script>

<style>

</style>
